import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import userRating from 'website/containers/user-action/userRating';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import userFriendsRating from 'website/containers/user/userFriendsRating';
// faceBookRCWidget
import facebookWidgets from 'website/module/ui/facebookWidgets';

// bootstrap the application / store
applicationBootstrap().then(() => {
  // fb rc widget init
  facebookWidgets();

  // Social user Action
  userFriendsRating();
  userRating();
  userWantToSee();

  socialActionsBootstrap();
});
